<template>
	<div>
	    <b-modal ref="modal_compta" hide-footer>
            <template v-slot:modal-title>
                {{ $t('invoice.selection_compta') }}
            </template>

            <b-alert show variant="warning" class="mt-1">
                {{ $t('invoice.alert_multi_compta') }}
            </b-alert>

            <e-select
                track-by="tiers_id"
                label="tiers_rs"
                :placeholder="$t('invoice.select_compta')"
                :options="authors"
                v-model="author_selected"
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
            >
            </e-select>

        	<div class="text-center mt-2">
				<b-button variant="primary" :disabled="!author_selected" @click="nextAuthorSelected"><font-awesome-icon :icon="['fal', 'long-arrow-right']" /> {{ $t("global.continuer") }}</b-button>
        	</div>
	    </b-modal>

	    <b-modal ref="modal_numero_interne" hide-footer>
            <template v-slot:modal-title>
                {{ $t('invoice.selection_ref_client') }}
            </template>

            <div class="from-group">
            	<label>{{ $t('invoice.selectionnez_refs_clients') }} :</label>
	            <e-select
	                :placeholder="$t('invoice.select_compta')"
	                :options="all_ref_clients"
	                v-model="ref_client_selected"
	                :searchable="true"
	                :allow-empty="false"
	                multiple
	            >
            	</e-select>
            </div>

        	<div class="text-center mt-2">
				<b-button variant="primary" :disabled="!author_selected" @click="nextNumeroInterneSelected"><font-awesome-icon :icon="['fal', 'long-arrow-right']" /> {{ $t("global.continuer") }}</b-button>
        	</div>
	    </b-modal>

	    <b-modal ref="modal" hide-footer no-close-on-backdrop>
	        <template v-slot:modal-title v-if="!confirmation_zero">
	            {{ $t("action.facturer") }}
	        </template>
	        <template v-slot:modal-title v-else>
	            {{ $t("action.confirmation") }}
	        </template>

            <LoadingSpinner v-if="loading_modal" class="col-12" />
            <LoadingSpinner v-else-if="processing" class="col-12" :text_trad="trad_loading" />

	        <template v-else-if="confirmation_zero">
	            <h3>{{ $t("invoice.ttc_0_confirmation_1") }} {{ actual_price_and_currency }}</h3> 
	            <h3>{{ $t("invoice.ttc_0_confirmation_2") }}</h3>
	            <b-button class="mt-3 rounded-pill" block @click.prevent="continueInvoiceZero" variant="primary">{{ $t("global.continuer") }}</b-button>
	            <b-button class="mt-3 rounded-pill" block @click.prevent="cancelInvoiceZero" variant="primary">{{ $t("global.annuler") }}</b-button>
	        </template>

	        <template v-else>
	            <div class="form-group">
	            	<div class="row align-items-center mb-2">
	            		<div class="col-auto pr-0">
	            			<label for="date" class="mb-0">{{ $t('tiers.date_facture') }}</label>
	            		</div>
	            		<div class="col-auto">
	            			<div class="date_derniere_facturation" v-if="last_invoice_date">( {{ $t('invoice.date_derniere_facturation') }}: <a href="#" @click="assignDate(last_invoice_date.invoice_date)">{{ last_invoice_date.formated_date }} </a>)</div>
	            		</div>
	            	</div>
	            	<e-datepicker v-model="date" />
	            	<!-- <small class="form-text text-muted">{{ $t('invoice.definir_date_facturation_text') }}</small> -->
	            </div>

	            <div v-if="accounting_closed" class="mt-2 alert alert-danger">
	            	{{ $t('invoice.accounting_closed') }} <router-link :to="{ name: 'AccountingInformations', params: { accountingplan_id: accounting_plan.accountingplan_id }}">{{ $t('support.cliquant_ici') }}</router-link>
	            </div>

	            <div class="form-group" v-if="date > today && can_display_renew">
                    <label for="date_automatique">{{ $t('invoice.renouvellement_facture') }}</label>
                    <e-select
                        v-model="renew"
                        id="code"
                        track-by="label"
                        label="label"
                        :placeholder="$t('invoice.search_renew')"
                        :options="renew_options"
                        :searchable="true"
                        :allow-empty="false"
                        :show-labels="false"
                    >
                    </e-select>
                </div>

	            <div class="mt-4">
	            	<h5 v-if="author_selected">{{ $t('invoice.clients_facture_par') }} {{ author_selected.tiers_rs }}</h5>
            		<table class="table b-table table-striped table-hover border rounded mb-2">
            			<thead class="sticky">
            				<tr>
            					<th>{{ $t('invoice.flux_client') }}</th>
            					<th class="text-right d-none d-sm-table-cell">{{ $t('invoice.invoicedetails_ht') }}</th>
            					<th class="text-right d-none d-sm-table-cell">{{ $t('invoice.vat_label') }}</th>
            					<th class="text-right">{{ $t('invoice.invoicedetails_ttc') }}</th>
            				</tr>
						</thead>
						<tbody>
							<tr v-for="invoice in invoices" :key="invoice.tiers.tiers_id">
								<td><router-link :to="{ name: 'tiersFiche', params: { tiers_id: invoice.tiers.tiers_id }}" :style="{ textDecoration: invoice.tiers.tiers_archive === 1 ? 'line-through' : 'none' }">{{ invoice.tiers.tiers_rs }}</router-link></td>
								<td class="text-right d-none d-sm-table-cell">{{ invoice.ht }}</td>
								<td class="text-right d-none d-sm-table-cell">{{ invoice.vat }}</td>
								<td class="text-right">{{ invoice.ttc }}</td>
							</tr>
						</tbody>
					</table>
	            </div>

	            <div v-if="tiers.length == 1" class="mt-4">
					<label v-b-toggle.duedate class="d-flex align-items-center label-ligne"><span>{{ $t('invoice.perso_echeances') }}</span><font-awesome-icon :icon="['far', 'angle-down']" class="ml-auto"/></label>
		            <b-collapse v-if="params_to_send.invoices.length > 0" id="duedate" class="border rounded mb-2">
	                    <div v-for="(duedate, duedate_key) in params_to_send.invoices[0].duedates" class="row p-2" :key="'duedate_'+duedate_key">
	                        <div class="col-5">
	                            <e-datepicker v-model="duedate.date" :class="{ 'is-invalid': errors && errors.indexOf('Erreur date duedate ' + duedate.date) > -1 }"></e-datepicker>
	                        </div>
	                        <div class="col-4">
	                            <input class="form-control" type="text" v-model="duedate.amount" @change="calculDuedateAmount" :class="{ 'is-invalid': errors && errors.indexOf('Erreur somme duedate ' + duedate.amount) > -1 }">
	                        </div>
	                        <div v-if="duedate_key == params_to_send.invoices[0].duedates.length - 1" class="col-3">
	                    		<b-button variant="primary" class="w-100" @click.prevent="add_duedate(params_to_send.invoices[0])"><font-awesome-icon :icon="['fal', 'plus']" class="ml-1"/> {{ $t('global.ajouter') }}</b-button>
	                        </div>
	                    </div>
					</b-collapse>
				</div>

				<div class="mt-4">
					<label v-b-toggle.page class="d-flex align-items-center label-ligne"><span>{{ $t('invoice.option_mise_page') }}</span> <font-awesome-icon :icon="['far', 'angle-down']" class="ml-auto"/></label>
		            <b-collapse id="page" class="border rounded mb-2">
		            	<div class="row p-2">
		            		<div class="col-12">
		            			<e-select
	                                id="model"
	                                track-by="model_label"
	                                label="model_label"
	                                :placeholder="getTrad('invoice.modele_invoice')"
	                                :selectedLabel="getTrad('global.selected_label')"
	                                :options="all_models"
	                                v-model="model_selected"
	                                :searchable="true"
	                                :allow-empty="false"
	                                :loading="loading_model"
	                                :show-labels="false"
	                            >
	                            </e-select>
		            		</div>
		            		<div class="col-12 mt-2">
                                <e-select
                                    id="search_compte"
                                    track-by="checkdepositconfiguration_id"
                                    label="checkdepositconfiguration_iban"
                                    :placeholder="getTrad('invoice.compte_bancaire')"
                                    :selectedLabel="getTrad('global.selected_label')"
                                    :options="all_ribs"
                                    v-model="rib_selected"
                                    :searchable="true"
                                    :allow-empty="true"
                                    :show-labels="false"
                                >
                                    <template slot="singleLabel" slot-scope="{ option }">{{ option.checkdepositconfiguration_libelle }} {{ option.checkdepositconfiguration_iban }}</template>
                                    <template slot="option" slot-scope="{ option }">{{ option.checkdepositconfiguration_libelle }} {{ option.checkdepositconfiguration_iban }}</template>
                                </e-select>
		            		</div>
                            <div class="col-6 my-2">
                                <input type="text" class="form-control" v-model="ref_client" :placeholder="$t('invoice.ref_client')">
                            </div>
                            <div class="col-6 my-2">
                                <input type="text" class="form-control" v-model="dossier_interne" :placeholder="$t('invoice.dossier_interne')">
                            </div>
		            	</div>
		            </b-collapse>
		        </div>
				<b-form-checkbox v-if="hasArchivedTiers" id="check_archive" v-model="enable_confirm_button"><label for="check_archive">{{ $t('invoice.force_invoice') }}</label></b-form-checkbox>
		        <div class="row mt-4">
	        		<div class="col-12 text-center">
	            		<b-button variant="secondary" @click="preview"><font-awesome-icon :icon="['fas', 'eye']" /> {{ $t('invoice.preview_baf.title') }}</b-button>
	            		<b-button :disabled="accounting_closed !== false || (hasArchivedTiers && enable_confirm_button == false)" variant="primary" @click="checkIfFirstInvoiceMonth" class="ml-2">{{ $t("invoice.create_invoice") }} <font-awesome-icon v-if="processing || processing_check" :icon="['fas', 'spinner']" pulse /><font-awesome-icon v-else :icon="['fal', 'long-arrow-right']" /></b-button>
	        		</div>
		        </div>
	        </template>
	    </b-modal>

	    <b-modal ref="confirmation_first_invoice" hide-footer>
	        <template v-slot:modal-title>
	            {{ $t("invoice.title_first_invoice_of_month") }}
	        </template>
	        <div class="row justify-content-around">
	            <div class="col">
	                {{ $t("invoice.first_invoice_of_month") }}
	                
	                <b-button class="mt-3 rounded-pill" block @click.prevent="checkForm" variant="primary"><font-awesome-icon v-if="processing_check" :icon="['fas', 'spinner']" pulse /> {{ $t("global.continuer") }}</b-button>
	                <b-button class="mt-3 rounded-pill" block @click.prevent="closeFirstInvoiceModal" variant="primary">{{ $t("global.annuler") }}</b-button>
	            </div>
	        </div>
	    </b-modal>

		<b-modal size="xl" ref="modalPreview" hide-footer @hidden="base64 = null">
            <template v-slot:modal-title>
                {{ $t("action.previsualiser") }}
            </template>

            <iframe v-if="base64 != null" :src="'data:application/pdf;base64,' + base64" height="1000px" width="100%" style="position:relative"></iframe>
            <div v-else>
				<b-progress :max="invoice_details.length" height="2rem" show-progress>
					<b-progress-bar :value="progress_preview">
                		<div class="innerProgress w-100 text-center">{{ $t('global.chargement') }} {{((progress_preview / invoice_details.length) * 100).toFixed(0)}}%</div>
					</b-progress-bar>
				</b-progress>
            </div>
        </b-modal>

        <ModalAvoirCC ref="modal_avoir_cc" :callback="submitModalCC"/>
        <ModalSendInvoice ref="modal_send_invoice" @submit="submitSend"/>

        <b-modal ref="tiers_peppol" hide-footer>
            <template v-slot:modal-title>
                {{ $t('tiers.peppol_manquant') }}
            </template>

            <div>
            	<div>
	                <b-alert v-if="peppol_asked" show variant="warning" class="mt-1">
	                    {{ $t('invoice.message_peppol_manquant') }}
	                </b-alert>

	            	<div class="mt-2" v-for="tiers in tiers_peppol" :key="tiers.tiers_id">
	            		<label>{{ tiers.tiers_rs }}</label>
	                    <input type="text" class="form-control" v-model="tiers.tiers_peppol_id" :class="{'is-invalid': tiers.tiers_peppol_error}">
	            	</div>

		            <span>{{ $t('tiers.message_peppol_lien') }} <a href="https://directory.peppol.eu/public" target="_blank">{{ $t('global.ici') }}</a></span>
            	</div>
            	<div class="text-center mt-2">
					<b-button v-if="peppol_asked" variant="primary" @click="savePeppol"><font-awesome-icon v-if="processing_peppol" :icon="['fas', 'spinner']" pulse /><font-awesome-icon v-else :icon="['far', 'save']" /> {{ $t("global.enregistrer") }}</b-button>
					<b-button v-else variant="primary" @click="confirmAskPeppol"><font-awesome-icon v-if="processing_peppol" :icon="['fas', 'spinner']" pulse /><font-awesome-icon v-else :icon="['far', 'search']" /> {{ $t("tiers.ask_peppol") }}</b-button>
					<b-button variant="secondary" :disabled="tiers_peppol_error" class="ml-2" @click="loadModal"><font-awesome-icon :icon="['fal', 'long-arrow-right']" /> {{ $t("global.continue_anyway") }}</b-button>
            	</div>
            </div>
        </b-modal>
	</div>
</template>

<script type="text/javascript">
	import Invoice from "@/mixins/Invoice.js"
	import Tiers from "@/mixins/Tiers.js"
	import Model from "@/mixins/Model.js"
	import Contract from "@/mixins/Contract.js"
	import _groupBy from 'lodash/groupBy'
	import _uniq from 'lodash/uniq'
	import ContractCleaner from '@/assets/js/cache/cleaners/ContractCleaner'

	export default {
		name: 'ModalAddInvoice',
		mixins: [Invoice, Tiers, Model, Contract],
		props: ['bons'],
		data () {
			return {
				enable_confirm_button: false,
				bons_grouped: [],
				authors: [],
				author_selected: null,
				invoice_details: [],
				date: new Date(),
				last_invoice_date: {},
				accounting_closed: false,
				config_duedate: {},
				amount: {},
				confirmation_zero: false,
				actual_price_and_currency: '',
				params_to_send: {
					invoices: [],
					invoicedetails_ids: []
				},
				loading_modal: false,
				processing: false,
				processing_check: false,
				invoices: [],
				tiers: [],
				errors: [],
				loading_model: false,
				all_models: [],
				model_selected: null,
                invoicedetails_ids: [],
                progress_id: '',
                progress_preview: 0,
                base64: null,
                all_ribs: [],
                rib_selected: null,
                ref_client: '',
				dossier_interne: '',
				ribs_from_stallions: {},
				can_display_renew: false,
				renew_options: [{
						"code": 'null',
						"label": this.getTrad("invoice.renew.no")
					},
					{
						"code": 'mensuel',
						"label": this.getTrad("invoice.renew.mensuel")
					},
					{
						"code": 'annuel',
						"label": this.getTrad("invoice.renew.annuel")
				}],
				renew: {
					"code": 'null',
					"label": this.getTrad("invoice.renew.no")
				},
				today: new Date(),
				invoices_created: [],
				all_ref_clients: [],
				ref_client_selected: '',
				accounting_plan: null,
				tiers_peppol: [],
				processing_peppol: false,
				peppol_asked: false,
				tiers_peppol_error: true
			}
		},

		methods: {
			async openModal(invoicedetails_ids) {
				const invoice_details = this.bons.filter(bon => invoicedetails_ids.includes(bon.invoicedetails_id))
				this.bons_grouped = _groupBy(invoice_details, 'invoicedetails_author')
				if(Object.keys(this.bons_grouped).length > 1) {
					this.authors = Object.values(this.bons_grouped).map(group => group[0].author)
					this.$refs.modal_compta.show()
				}
				else {
					this.invoice_details = invoice_details
					this.author_selected = invoice_details[0].author
					this.nextAuthorSelected()
				}
			},

			nextAuthorSelected() {
				this.invoice_details = this.bons_grouped[this.author_selected.tiers_id]
				this.$refs.modal_compta.hide()

				this.all_ref_clients = [...new Set(this.invoice_details.map(detail => detail.invoicedetails_ref_client))]
				this.ref_client_selected = this.all_ref_clients
				if(this.all_ref_clients.length > 1) {
					this.$refs.modal_numero_interne.show()
				}
				else {
					this.checkPeppolNumber()
				}
			},

			nextNumeroInterneSelected() {
				this.$refs.modal_numero_interne.hide()
				this.invoice_details = this.invoice_details.filter(detail => this.ref_client_selected.includes(detail.invoicedetails_ref_client))
				this.checkPeppolNumber()
			},

			checkPeppolNumber() {
				const details_peppol = this.invoice_details.filter(details => ((details.author.tiers_country.toString() == '21' || details.author.tiers_country.toString() == '290') && (details.tiers.tiers_country.toString() == '21' || details.tiers.tiers_country.toString() == '290')))

				if(details_peppol.length == 0) {
					this.loadModal()
					return false
				}

				const details_tiers = _groupBy(details_peppol, 'invoicedetails_tiers')
				let tiers = []
				for(let i in details_tiers) {
					tiers.push(details_tiers[i][0].tiers)
				}
				this.tiers_peppol = tiers
				this.$refs['tiers_peppol'].show()
				this.confirmAskPeppol()
			},

			async confirmAskPeppol() {
				this.processing_peppol = true
				const tiers_ids = this.tiers_peppol.map(tiers => tiers.tiers_id)
				const res = await this.askPeppol(tiers_ids)
				this.tiers_peppol.forEach(tiers => {
					const res_tiers = res.find(r => r.tiers_id == tiers.tiers_id)
					tiers.tiers_peppol_error = false
					if(res_tiers.peppol && res_tiers.peppol !== 'error') {
						tiers.tiers_peppol_id = res_tiers.peppol.peppol_id
					}
					if(res_tiers.peppol && res_tiers.peppol == 'error') {
						tiers.tiers_peppol_error = true
					}
				})
				this.processing_peppol = false
				this.peppol_asked = true

				//si tous les tiers ont un numéro valide je passe à l'étape d'après
				if(this.tiers_peppol.filter(tiers => !tiers.tiers_peppol_id || tiers.tiers_peppol_error).length == 0) {
					this.loadModal()
				}
				this.tiers_peppol_error = this.tiers_peppol.filter(tiers => tiers.tiers_peppol_error).length > 0
			},

			async loadModal() {
				this.$refs['tiers_peppol'].hide()
				this.$refs.modal.show()
				this.loading_modal = true
				this.tiers = []
				this.confirmation_zero = false

				this.today = new Date()
				this.today.setHours(0)
				this.today.setMinutes(0)
				this.today.setSeconds(0)

				this.date = new Date()
				this.params_to_send = {
					invoices: [],
					invoicedetails_ids: []
				}
				this.ribs_from_stallions = {}
				this.renew = this.renew_options.find(renew => renew.code == 'null')

				this.dossier_interne = [...new Set(this.invoice_details.filter(detail => !!detail.invoicedetails_dossier_interne).map(detail => detail.invoicedetails_dossier_interne))].join(', ')
				this.ref_client = this.ref_client_selected.join(', ')

				const invoices = {}
				// regroupe les lignes par tiers pour calculer les totaux à afficher
				this.invoice_details.forEach(detail => {
					if(!Object.prototype.hasOwnProperty.call(invoices, detail.invoicedetails_tiers)) {
						this.params_to_send.invoices.push({
							'author_id': detail.invoicedetails_author,
							'author_currency': detail.author.tiers_currency,
							'tiers_id': detail.invoicedetails_tiers,
							'group_by_author_tiers': detail.group_by_author_tiers
						})

						invoices[detail.invoicedetails_tiers] = {
							'tiers': detail.tiers,
							'ht': 0,
							'vat': 0,
							'vat_table': {}
						}

						this.tiers.push(detail.tiers)
					}

					invoices[detail.invoicedetails_tiers].ht += detail.invoicedetails_ht
					if(!Object.prototype.hasOwnProperty.call(invoices[detail.invoicedetails_tiers].vat_table, detail.invoicedetails_vat)) {
						invoices[detail.invoicedetails_tiers].vat_table[detail.invoicedetails_vat] = {
							'vat_value': detail.vat.vat_value,
							'amount': 0
						}
					}
					invoices[detail.invoicedetails_tiers].vat_table[detail.invoicedetails_vat].amount += detail.invoicedetails_ht

					if(detail.contract && detail.contract.contract_config && detail.contract.contract_config.contractconfig_configuration) {
						if(!Object.prototype.hasOwnProperty.call(this.ribs_from_stallions, detail.invoicedetails_tiers)) {
							this.ribs_from_stallions[detail.invoicedetails_tiers] = []
						}
						this.ribs_from_stallions[detail.invoicedetails_tiers].push(detail.contract.contract_config.contractconfig_configuration)
					}
				})

				// for(let tiers_id in invoices) {
				// 	Object.values(invoices[tiers_id].vat_table).forEach(vat => {
				// 		invoices[tiers_id].vat += vat.amount * vat.vat_value
				// 	})
				// 	invoices[tiers_id].vat = parseInt(invoices[tiers_id].vat*100)/100
				// 	invoices[tiers_id].ttc = invoices[tiers_id].vat + invoices[tiers_id].ht

				// 	invoices[tiers_id].ht = await this.priceFormat(invoices[tiers_id].ht, this.author_selected.tiers_currency, true)
				// 	invoices[tiers_id].vat = await this.priceFormat(invoices[tiers_id].vat, this.author_selected.tiers_currency, true)
				// 	invoices[tiers_id].ttc = await this.priceFormat(invoices[tiers_id].ttc, this.author_selected.tiers_currency, true)
				// }
				this.invoices = invoices

				this.params_to_send.invoicedetails_ids = this.invoice_details.map(detail => detail.invoicedetails_id).join(',')

                const tiers_ids = this.tiers.map(tier => tier.tiers_id)
                const data = await this.prepareCalculInvoice(this.invoice_details[0].author.tiers_id, tiers_ids, this.params_to_send)

                this.last_invoice_date = data.last_date
                if(this.last_invoice_date && this.last_invoice_date.invoice_date) {
                    this.last_invoice_date.invoice_date = new Date(this.last_invoice_date.invoice_date)
                    this.last_invoice_date.formated_date = this.formatDate(this.last_invoice_date.invoice_date)
                }
                this.config_duedate = data.config_duedate
                this.amount = data.amount

				let a = Object.keys(this.amount)[0]
				const numeric_ttc = parseFloat(this.amount[a].invoice_ttc.replace(',', '.'))
				const numeric_ht = parseFloat(this.amount[a].invoice_ht.replace(',', '.'))
				if (numeric_ttc === 0 && numeric_ht === 0) {
					this.actual_price_and_currency = await this.priceFormat(numeric_ttc, this.author_selected.tiers_currency, true)
					this.confirmation_zero = true
				}

				for(let i in this.amount) {
					const tiers = i.split('_')[1]
					this.invoices[tiers].ht = this.amount[i].invoice_ht
					this.invoices[tiers].vat = this.amount[i].invoice_vat
					this.invoices[tiers].ttc = this.amount[i].invoice_ttc_formatted
				}

				await this.add_duedate()
                
                this.can_display_renew = false
                const nb_ligne_vierge = this.invoice_details.filter(detail => detail.invoicedetails_actes == null && detail.invoicedetails_contract == null && detail.invoicedetails_horsepensionperiode == null)
				if(nb_ligne_vierge.length == this.invoice_details.length) {
					this.can_display_renew = true
				}

				this.loading_modal = false

				this.accounting_plan = await this.loadAccountingPlanByEntity(this.author_selected.tiers_id)
				this.all_ribs = await this.getCheckDepositConfigListe(this.accounting_plan.accountingplan_id)
                const rib_default = {
                    checkdepositconfiguration_default: false,
                    checkdepositconfiguration_id: 0,
                    checkdepositconfiguration_iban: this.getTrad('invoice.compte_bancaire_default'),
                }
                this.all_ribs.push(rib_default)
                this.rib_selected = rib_default

				this.loading_model = true
                let models = await this.loadAllModel(this.accounting_plan.accountingplan_id, ['accounting_plan'])
                this.all_models = models.filter(model => (model.type.modeltype_template === 'facture'))
                const model_default = {
                    model_default: false,
                    model_id: 0,
                    model_label: this.getTrad('invoice.model_default'),
                }
                this.all_models.push(model_default)
                this.model_selected = model_default
                this.loading_model = false
			},
            async add_duedate(tab_invoice) {
				if(tab_invoice != undefined && !Array.isArray(this.params_to_send)) {
					for (let i = 0; i < this.params_to_send.invoices.length; i++) {
						//J'ajoute une date là ou j'ai choisi de cliquer sur ajouter
						if(this.params_to_send.invoices[i].group_by_author_tiers == tab_invoice.group_by_author_tiers) {
							let current = new Date(this.date);
							const key = this.params_to_send.invoices[i].author_id + "_" + this.params_to_send.invoices[i].tiers_id

							this.params_to_send.invoices[i].duedates.push({
								'date': undefined,
								'amount': "0",
								'amount_float': 0,
								'total_invoice': Math.round(this.amount[key].invoice_ttc.toString().toFloat() * 10000000 / 100000)
							})
						}
					}
					this.calculDuedateDate(true)
				}
				else {
					this.calculDuedateDate()
				}
			},
            async calculDuedateDate(use_prev = false) {
                let new_invoices_tab = []
                if(Array.isArray(this.params_to_send)) return
                for (let i = 0; i < this.params_to_send.invoices.length; i++) {
                    let author_id = this.params_to_send.invoices[i].author_id
                    let tiers_id = this.params_to_send.invoices[i].tiers_id
                    let key = author_id + "_" + tiers_id
                    let current_date = this.date

                    //Je regarde si je dois prendre la date précédente pour calculer les échéances à venir
                    if(use_prev) {
                        if(this.params_to_send.invoices[i].duedates != undefined) {
                            let all_amount = parseInt(this.amount[key].invoice_ttc.toString().toFloat() * 10000000 / 100000)

                            //Je parcours les echeances pour calculer la date
                            for (let j = 0; j < this.params_to_send.invoices[i].duedates.length; j++) {

                                let date = null
                                let current = null
                                let amount_float = 0

                                if(j == 0) {
                                    if(this.params_to_send.invoices[i].duedates[j] != undefined)  {
                                        current = this.params_to_send.invoices[i].duedates[j].date
                                    }
                                    else {
                                        current = this.calculNextDateDuedate(this.config_duedate[tiers_id], current_date)
                                    }
                                }
                                else {
                                    if(this.params_to_send.invoices[i].duedates[j].date != undefined) {
                                        current = this.params_to_send.invoices[i].duedates[j].date
                                    }
                                    else {
                                        current = this.calculNextDateDuedate(this.config_duedate[tiers_id], this.params_to_send.invoices[i].duedates[j - 1].date)
                                    }
                                }

                                //Si j'ai une valeur de renseignée, je la reprend
                                if(this.params_to_send.invoices[i].duedates[j].amount != undefined) {
                                    amount_float = parseInt(this.params_to_send.invoices[i].duedates[j].amount.toString().toFloat() * 10000000 / 100000)
                                }

                                if((j + 1) == this.params_to_send.invoices[i].duedates.length) {
                                    amount_float = all_amount
                                }

                                this.params_to_send.invoices[i].duedates[j] = {
                                    'date': current,
                                    'amount': (amount_float / 100).toString().toFloat(),
                                    'amount_float': amount_float,
                                    'total_invoice': this.amount[key].invoice_ttc_vanilla
                                }
                                all_amount -= amount_float

                                if(all_amount < 0) {
                                    all_amount = 0
                                }
                            }
                        }
                    }
                    else {
                        let date = this.calculNextDateDuedate(this.config_duedate[tiers_id], current_date)

                        let current = new Date(date);
                        let amount_float = parseInt(this.amount[key].invoice_ttc.toString().toFloat() * 10000000 / 100000)
                        this.params_to_send.invoices[i].duedates = [{
                            'date': current,
                            'amount': this.amount[key].invoice_ttc,
                            'amount_float': amount_float,
                            'total_invoice': this.amount[key].invoice_ttc_vanilla
                        }]
                    }
                    new_invoices_tab.push(this.params_to_send.invoices[i])
                }

                this.$set(this.params_to_send, 'invoices', new_invoices_tab)
            },
            assignDate(date) {
				this.date = date
			},
            async checkIfFirstInvoiceMonth() {
				this.processing_check = true
				const elems = await this.checkFirstInvoiceMonth(this.date.toDateInputValue(), this.params_to_send.invoicedetails_ids)
				this.processing_check = false
				if(elems.nb == 0) {
					this.$refs.confirmation_first_invoice.show()
				}
				else {
					await this.checkForm()
				}
			},
			closeFirstInvoiceModal() {
				this.$refs.confirmation_first_invoice.hide()
			},
            continueInvoiceZero() {
				this.confirmation_zero = false
			},
            cancelInvoiceZero() {
				this.$refs.modal.hide()
			},
            calculDuedateAmount() {
				for(let i in this.params_to_send.invoices) {
					for(let j in this.params_to_send.invoices[i].duedates) {
						this.params_to_send.invoices[i].duedates[j].amount_float = this.params_to_send.invoices[i].duedates[j].amount*100
					}
				}
			},
			preview() {
				const infos = this.tiers.map(tier => ({
					'author_id': this.author_selected.tiers_id,
					'tiers_id': tier.tiers_id
				}))

				this.progress_id = Math.random().toString(16).slice(2)
				this.progress_preview = 0

				let params_to_send = {
					"invoices": infos,
					"invoicedetails_ids": this.invoice_details.map(detail => detail.invoicedetails_id).join(','),
					"progress_id": this.progress_id,
					"model": this.model_selected && this.model_selected.model_id !== 0 ? this.model_selected.model_id : null,
					"check_deposit": this.rib_selected && this.rib_selected.checkdepositconfiguration_id !== 0 ? this.rib_selected.checkdepositconfiguration_id : null
				}

				let download = true 
				if(infos.length == 1) {
					download = false
				}
				this.$refs.modalPreview.show()

				this.previewInvoice(params_to_send, download).then(res => {
					if(infos.length == 1) {
						this.base64 = res
					}
					else {
						this.$refs.modalPreview.hide()
					}
					this.progress_id = null
				})
				this.updateProgressPreview()
			},
			async updateProgressPreview() {
				if(!this.progress_id) return false
					
				this.progress_preview = await this.getProgressPreviewInvoice(this.progress_id)
				if(this.progress_preview < this.invoice_details.length) {
					setTimeout(this.updateProgressPreview, 1500);
				}
			},
			checkForm: async function() {
				this.closeFirstInvoiceModal()

				if(!this.processing) {
					this.processing = true
					this.errors = []

					if(this.date == null) {
						this.errors.push("Erreur date null")
					}

					if(!Date.parse(this.date)) {
						this.errors.push("Erreur wrong date")
					}
					//Je vais regarder que mes dates d'échéances soient supérieurs ou égales à ma date de facturation, et regarder le montant
					for (let i = 0; i < this.params_to_send.invoices.length; i++) {
						let somme = 0

                        if(this.change_rib && (this.params_to_send.invoices[i].rib == undefined || this.params_to_send.invoices[i].rib == null)) {
                            this.errors.push("Erreur compte bancaire (rib)")
                        }

                        //Si j'ai qu'un seul rib etalon de selectionné pour une entité/tiers, et que je n'ai pas choisi manuellement mon rib
                        if(this.ribs_from_stallions[this.params_to_send.invoices[i].group_by_author_tiers] != undefined
                            && _uniq(this.ribs_from_stallions[this.params_to_send.invoices[i].group_by_author_tiers]).length == 1
                            && (this.params_to_send.invoices[i].rib == undefined || this.params_to_send.invoices[i].rib == null)
                            && this.use_rib_stallions
                        ) {
                            this.params_to_send.invoices[i].rib = {
                                "checkdepositconfiguration_id": this.ribs_from_stallions[this.params_to_send.invoices[i].group_by_author_tiers][0]
                            }
                        }
                        else if(this.rib_selected && this.rib_selected.checkdepositconfiguration_id !== 0) {
                            this.params_to_send.invoices[i].rib = this.rib_selected
                        }

                        if(this.model_selected && this.model_selected.model_id !== 0) {
	                        this.params_to_send.invoices[i].model = this.model_selected
                        }

                        if(this.params_to_send.invoices[i].duedates > 1) {
	                        this.params_to_send.invoices[i].duedates = this.params_to_send.invoices[i].duedates.filter(duedate => parseInt(duedate.amount) !== 0)
                        }
						for (let j = 0; j < this.params_to_send.invoices[i].duedates.length; j++) {
							if(j == 0) {
								somme = this.params_to_send.invoices[i].duedates[j].total_invoice
							}

							if(!Date.parse(this.params_to_send.invoices[i].duedates[j].date) || this.params_to_send.invoices[i].duedates[j].date < this.date) {
								this.errors.push("Erreur date duedate " + this.params_to_send.invoices[i].duedates[j].date)
							}

							somme -= parseInt(this.params_to_send.invoices[i].duedates[j].amount.toString().toFloat() * 10000000 / 100000)
						}
						if(somme != 0) {
							this.errors.push("Erreur somme duedate " + this.params_to_send.invoices[i].duedates[0].amount)
						}
                    }

					if(this.errors.length == 0) {
						let renew = null
						if(this.date > this.today) {
							if(this.renew.code != 'null') {
								renew = this.renew.code
							}
						}

						this.params_to_send.date = this.date
						this.params_to_send.renew = renew
						this.params_to_send.ref_client = this.ref_client
						this.params_to_send.dossier_interne = this.dossier_interne

						const result = await this.createInvoice(this.params_to_send);
						if(result && result.code_retour == 0) {
							const details_contract = this.invoice_details.filter(details => details.invoicedetails_contract)
							if(details_contract.length > 0) {
								const contract_ids = _uniq(details_contract.map(details => details.invoicedetails_contract))
			                    await this.$sync.force(true)
			                	ContractCleaner.inst().onMutation(contract_ids, ['articles'])
			                	this.updateContract(contract_ids)
			                }
							this.invoices_created = result.retour
							if(this.date <= this.today) {
								await this.$refs.modal_avoir_cc.init_component(this.invoices_created)
							}
							else {
								this.submitModalCC()
							}
							if(this.$refs.modal) {
								this.$refs.modal.hide()
							}
						} else {
							this.form_message = "error.LEP"
						}
					}
					else {
						this.form_message = "formulaire.erreur_champs_non_remplis"
					}

					this.processing = false
				}
			},
			submitModalCC() {
                this.$refs.modal_send_invoice.openModal(this.invoices_created)
			},
			submitSend() {
				this.$emit('submit')
			},
			async savePeppol() {
				const peppol = this.tiers_peppol.map(t => ({tiers_id: t.tiers_id, tiers_peppol_id: t.tiers_peppol_id}))
				this.processing_peppol = true
				await this.editTiersPeppol(peppol)
				this.processing_peppol = false
				this.confirmAskPeppol()
			}
		},

		computed: {
			trad_loading() {
				return this.invoices.length == 1 ? 'invoice.creation_invoice' : 'invoice.creation_invoices'
			},
			hasArchivedTiers() {
				return Object.values(this.invoices).filter(invoice => invoice.tiers.tiers_archive == 1).length > 0
			}
		},

		watch: {
			date(val) {
				this.date.setHours(0)
				this.date.setMinutes(0)
				this.date.setSeconds(0)
				if(this.accounting_plan) {
					this.accounting_closed = this.accounting_plan.accountingplan_closing_date < this.date
				}
				if(Object.values(this.config_duedate).length > 0) {
					this.calculDuedateDate()
				}
			},

			'accounting_plan.accountingplan_closing_date'(val) {
				if(val) {
					this.accounting_closed = this.accounting_plan.accountingplan_closing_date < this.date
				}
			}
		},

		components: {
            LoadingSpinner: () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
			ModalAvoirCC: () => import('@/components/Invoice/ModalAvoirCC'),
			ModalSendInvoice: () => import('@/components/Modals/ModalSendInvoice'),
		}
	}

</script>